import { ItemFilter } from 'services/useMyItems';

import { MyActivityHotDealsPage } from './MyActivityHotDealsPage';

export const MyActivityBoughtPage = () => <MyActivityHotDealsPage selectedFilter={ItemFilter.BOUGHT} />;
